export default "__VITE_ASSET__BZiz8QlU__"